import React from 'react';

/**
 * 관리자 페이지 통계 카드 컴포넌트
 * @param {Object} props
 * @param {React.ReactNode} props.icon - 카드 아이콘
 * @param {string} props.title - 통계 제목
 * @param {string|number} props.value - 메인 값
 * @param {string} props.subtitle - 부가 설명 (선택사항)
 * @param {string} props.iconColorClass - 아이콘 색상 클래스 (기본값: text-blue-600)
 */
const AdminStatCard = ({ 
  icon, 
  title, 
  value, 
  subtitle,
  iconColorClass = "text-blue-600"
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <div className={`h-8 w-8 ${iconColorClass}`}>
            {icon}
          </div>
        </div>
        <div className="ml-5 w-0 flex-1">
          <dl>
            <dt className="text-sm font-medium text-gray-500 truncate">{title}</dt>
            <dd className="text-lg font-medium text-gray-900">{value}</dd>
            {subtitle && (
              <dd className="text-xs text-gray-500">{subtitle}</dd>
            )}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default AdminStatCard;
